import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogPageComponent } from './containers/blog-page/blog-page.component';
import { ArchiveListComponent } from './components/archive-list/archive-list.component';
import { ArchiveListItemComponent } from './components/archive-list-item/archive-list-item.component';
import { BlogPostComponent } from './components/blog-post/blog-post.component';
import { QuillModule } from 'ngx-quill'
import { SharedModule } from '@src/app/shared/shared/shared.module';
import { BlogPostListComponent } from './components/blog-post-list/blog-post-list.component';

@NgModule({
  declarations: [
    BlogPageComponent,
    ArchiveListComponent,
    ArchiveListItemComponent,
    BlogPostComponent,
    BlogPostListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    QuillModule.forRoot()
  ]
})
export class BlogModule { }
